import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import { FaPencilAlt, FaArrowLeft, FaUser, FaEnvelope, FaPhone, FaAt } from "react-icons/fa";
import alertify from "alertifyjs";

import "./styles/Profile.css";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import ProfileLayout from "../components/ProfileLayout";
import { ListSkeleton } from "../components/Skeleton";
import UserAvatar from "../components/UserAvatar";
import * as actions from "../redux/actions/userActions";
import { syncSessionVerified } from "../redux/actions/sessionActions";
import { VERIFICATION_STATUS_APPROVED } from "../assets/userVerificationUtils";

function displayValue(value) {
  if (value == null) return "—";
  const text = String(value).trim();
  return text || "—";
}

function ProfileField({ icon: Icon, label, value, children, fullWidth }) {
  const display = children != null ? null : displayValue(value);
  const isEmpty = display === "—";

  return (
    <div
      className={`profile-view-field${
        fullWidth ? " profile-view-field--full" : ""
      }`}
    >
      <div className="profile-view-field__head">
        <span className="profile-view-field__icon">
          <Icon />
        </span>
        <span className="profile-view-field__label">{label}</span>
      </div>
      <div
        className={`profile-view-field__value${
          isEmpty ? " profile-view-field__value--empty" : ""
        }`}
      >
        {children != null ? children : display}
      </div>
    </div>
  );
}

class Profile extends React.Component {
  state = {
    avatar: "",
  };

  componentDidMount() {
    this.fetchProfile();
  }

  fetchProfile = async () => {
    try {
      await this.props
        .LoadProfile(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          } else if (this.props.profile?.Avatar) {
            this.setState({ avatar: this.props.profile.Avatar });
          }

          if (this.props.profile?.Verified) {
            this.props.SyncSessionVerified(true);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  renderPhone = () => {
    const { profile } = this.props;
    const phone = displayValue(profile.Phone);
    const country = profile.Country || {};
    const hasCountry = profile.Country !== undefined;
    const lada =
      country.PhoneCode || country.Lada || country.lada || "";

    if (!hasCountry && phone === "—") {
      return "—";
    }

    return (
      <span className="profile-view-phone">
        {hasCountry && (
          <span className="profile-view-phone__prefix">
            {country.Flag && (
              <img
                src={country.Flag}
                className="profile-view-flag"
                alt=""
              />
            )}
            {lada ? <span>+{lada}</span> : null}
          </span>
        )}
        <span>{phone}</span>
      </span>
    );
  };

  render() {
    const { profile, loading } = this.props;
    const { avatar } = this.state;
    const fullName = [profile.Name, profile.LastN].filter(Boolean).join(" ");
    const isLoading = loading && !profile.Username;

    return (
      <ProfileLayout>
        <div className="profile-view-page profile-edit-page">
          <div className="card profile-edit-card">
            {isLoading ? (
              <div className="profile-edit-form">
                <ListSkeleton />
              </div>
            ) : (
              <>
                <div className="profile-edit-header">
                  <h3 className="profile-edit-title">
                    @{displayValue(profile.Username)}
                  </h3>
                  {fullName && (
                    <p className="profile-edit-subtitle">{fullName}</p>
                  )}
                </div>

                <div className="profile-view-avatar-section">
                  <UserAvatar
                    src={avatar}
                    alt={profile.Username || "Avatar"}
                    verified={profile.Verified}
                    user={profile}
                    size="xl"
                    imgClassName="profile-edit-avatar-img"
                    initials={(profile.Username || "?").charAt(0).toUpperCase()}
                  />
                </div>

                <div className="profile-edit-form">
                  <section className="profile-view-info">
                    <div className="profile-view-fields">
                      <ProfileField
                        icon={FaUser}
                        label={<Translate value="profile_name" />}
                        value={`${profile.Name || ""} ${profile.LastN || ""}`.trim()}
                      />
                      <ProfileField
                        icon={FaEnvelope}
                        label={<Translate value="profile_email" />}
                        value={profile.Email}
                      />
                      <ProfileField
                        icon={FaPhone}
                        label={<Translate value="profile_phone" />}
                      >
                        {this.renderPhone()}
                      </ProfileField>
                      <ProfileField
                        icon={FaAt}
                        label={<Translate value="profile_username" />}
                        value={profile.Username}
                      />
                    </div>
                  </section>

                  <div className="profile-view-actions">
                    <Link to="/" className="profile-view-btn profile-view-btn--secondary">
                      <FaArrowLeft />
                      <Translate value="back" />
                    </Link>
                    <Link
                      to="/profile/edit"
                      className="profile-view-btn profile-view-btn--primary"
                    >
                      <FaPencilAlt />
                      <Translate value="profile_edit" />
                    </Link>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </ProfileLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    profile: reducer.user.item,
    error: reducer.user.error,
    loading: reducer.user.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadProfile: (user_id, token) =>
    dispatch(actions.loadItem({ user_id, token })),
  SyncSessionVerified: (verified) => dispatch(syncSessionVerified(verified)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
